/* tslint:disable */
/* eslint-disable */

/**
 * 1 = CNC
 * 
 * 2 = WeldedFabrication
 * 
 * 3 = ThermalCut
 * 
 * 4 = SurfaceFinish
 * 
 * 5 = ProfileOrSheetMetal
 * 
 * 6 = GeneralPart
 * 
 * 7 = Misc
 */
export enum PartType {
  CNC = 1,
  WeldedFabrication = 2,
  ThermalCut = 3,
  SurfaceFinish = 4,
  ProfileOrSheetMetal = 5,
  GeneralPart = 6,
  Misc = 7
}
